// extracted by mini-css-extract-plugin
export default {"button":"WhatsappButton_button__Hl71L"};